<template>
  <div>
    <v-toolbar
      app
      color="primary"
      dark flat>
    </v-toolbar>

    <v-container class="pa-0" align-center>
      <v-layout>
        <v-flex md4>
          <v-list>
            <v-subheader>
              You
            </v-subheader>

            <v-divider></v-divider>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Daily kill
                  <strong class="pull-right">
                    8000
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Full Price Freight
                  <strong class="pull-right">
                    $3.75
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Avg. Live Weight
                  <strong class="pull-right">
                    1250
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Long Haul Weight
                  <strong class="pull-right">
                    48000
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Head Per Delivery
                  <strong class="pull-right">
                    38
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex md4 class="px-3">
          <v-list>
            <v-subheader>
              Knobs/Adjustments
            </v-subheader>

            <v-divider></v-divider>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Freight Savings
                  <strong class="pull-right">
                    $0.25
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  LH Miles
                  <strong class="pull-right">
                    600
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  LH %
                  <strong class="pull-right">
                    35%
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex md4>
          <v-list>
            <v-subheader>
              Savings Opportunities
            </v-subheader>

            <v-divider></v-divider>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  LH Daily Kill
                  <strong class="pull-right">
                    2800
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  LH Daily Loads
                  <strong class="pull-right">
                    74
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Load Rate: Full
                  <strong class="pull-right">
                    $2,250.00
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Load Rate: {{ $t('site-title.brief') }}
                  <strong class="pull-right">
                    $2,100.00
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Load Rate: Savings
                  <strong class="pull-right">
                    $150.00
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md4></v-flex>
        <v-flex md4 class="px-3">
          <v-card>
            <v-toolbar color="accent" dark></v-toolbar>
            <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Per-Head Savings
                  <strong class="pull-right">
                    $3.95
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Daily Savings
                  <strong class="pull-right">
                    $11,052.63
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Weekly Savings
                  <strong class="pull-right">
                    $55,263.16
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>attach_money</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  Yearly Savings
                  <strong class="pull-right">
                    $2,873,684.21
                  </strong>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          </v-card>
        </v-flex>
        <v-flex md4></v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="isLtnAdmin">
      <v-layout row>
        <h3>Admin Config</h3>
      </v-layout>
      <v-layout row>
        <v-btn right :loading="loadingBtn"
               @click="saveChanges">
          Save
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex md4>
          <v-list>
            <v-subheader>
              {{ $t('site-title.brief') }}
            </v-subheader>

            <v-divider></v-divider>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Dispatch Fee %"
                              v-model="data.dispatch_fee">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Dispatch Fee Max"
                              v-model="data.dispatch_fee_max">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Dispatch Fee Min"
                              v-model="data.dispatch_fee_min">>
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Factor Fee"
                              v-model="data.factor_fee">>
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Loads % Factored"
                              v-model="data.loads_factored">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex md4 class="px-3">
        </v-flex>
        <v-flex md4>
          <v-list>
            <v-subheader>
              {{ $t('site-title.brief') }}
            </v-subheader>

            <v-divider></v-divider>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Load Dispatch"
                              v-model="data.load_dispatch">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Daily Load Dispatch"
                              v-model="data.daily_load_dispatch">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Weekly Load Dispatch"
                              v-model="data.weekly_load_dispatch">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Yearly Load Dispatch"
                              v-model="data.yearly_load_dispatch">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>


            <v-divider></v-divider>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Factor Amount"
                              v-model="data.factor_amount">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Loads Factored"
                              v-model="data.loads_factored">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Daily Factoring"
                              v-model="data.daily_factoring">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Weekly Factoring"
                              v-model="data.weekly_factoring">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Yearly Factoring"
                              v-model="data.yearly_factoring">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>label</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-text-field label="Bottom Line"
                              v-model="data.bottom_line">
                </v-text-field>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

export default {
  name: 'BeefPlantNumbers',
  computed: {
    ...mapGetters('profiles', ['isLtnAdmin']),
  },
  data() {
    return {
      dbRef: null,
      data: {},
      loadingBtn: false,
    };
  },
  methods: {
    async saveChanges() {
      this.loadingBtn = true;
      await this.dbRef.update(this.data);
      this.loadingBtn = false;
    },
  },
  created() {
    this.dbRef = firebase.database().ref('numbers');
    this.dbRef.once('value').then((val) => {
      this.$set(this, 'data', val.val());
    });
  },
};
</script>

<style lang="css" scoped>
  .pull-right {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/BeefPlantNumbers.vue